// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/audit-trail/components/audit-trail-header/audit-trail-header.less
// module id = 3875
// module chunks = 0